import React, { Fragment } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { getCurrency } from "../../../../../../legacyComponents/util/formating";
import { styles } from ".";

import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { AllowanceButtons } from ".";
import { Color } from "../../../../../../legacyComponents/config/config.styles";
import { MAX_BENEFIT_AGE_LIST } from "../../../../../../legacyComponents/util/api/apis/employer/PermissibleClass/constants";

export default function Component(props) {
  const { formik } = props;
  const { values, errors } = formik;

  return (
    <Fragment>
      <AllowanceButtons {...props} />
      <Typography sx={styles.error}>
        {errors?.uploadError || "\u00A0"}
      </Typography>

      {/*   @ts-ignore */}
      <ThemeProvider theme={createTheme({ components: styles.table })}>
        <Table>
          <TableBody sx={{ "& *": { textAlign: "center !important" } }}>
            <TableRow>
              <TableCell sx={{ width: "30%" }}>Age</TableCell>
              <TableCell sx={{ width: "70%" }}>Self Amount</TableCell>
            </TableRow>

            {Array(
              MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE -
                MAX_BENEFIT_AGE_LIST.MINIMUM_AGE +
                1,
            )
              .fill(null)
              .map((_, index) => {
                const age = index + MAX_BENEFIT_AGE_LIST.MINIMUM_AGE;
                const key = `selfAmount${age}`;

                // values hold ANNUAL cents; /12 gives monthly
                // cents and getCurrency divides by 100.
                let amount = getCurrency({
                  amount: values?.[key] / 12,
                  actions: ["divide"],
                  defaultReturn: "$0.00",
                });
                let error =
                  values?.columnErrors?.[
                    "row" + (index + MAX_BENEFIT_AGE_LIST.MINIMUM_AGE)
                  ] || false;
                return (
                  <TableRow key={key}>
                    <TableCell
                      style={{ color: error ? Color.danger : "#465578" }}
                    >
                      {age}
                    </TableCell>
                    <TableCell
                      style={{ color: error ? Color.danger : "#465578" }}
                    >
                      {amount}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </ThemeProvider>
    </Fragment>
  );
}
